const connectPanel = () => {
  const openedClass = 'is-opened';
  const showedClass = 'is-showed';

  const initConnect = () => {
    const _container = document.querySelector('[data-connect]');
    if (!_container) {
      return false;
    }
    const _panelToggle = document.querySelectorAll('[data-connect="toggle"]');
    const _message = document.querySelector('[data-connect="message"]');
    const _messageClose = '[data-connect="close"]';
    const defaultShowTime = 30 * 1000; // 30 sec
    const defaultRepeatTime = 2 * 1000 * 60; // 2 min
    const showTime = Number(_container.getAttribute('data-show-time')) * 1000 || defaultShowTime;
    const repeatTime = Number(_container.getAttribute('data-repeat-time')) * 1000 * 60 || defaultRepeatTime;

    const showMsg = () => {
        addClassFunc(_message, showedClass);
    };

    setTimeout(() => {
      showMsg();
    }, showTime);

    const closeMsg = () => {
      removeClassFunc(_message, showedClass);
      setTimeout(() => {
        showMsg();
      }, repeatTime);
    };

    _panelToggle.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        if (hasClass(_container, openedClass)) {
            removeClassFunc(_container, openedClass);
        } else {
            addClassFunc(_container, openedClass);
        }
      });
    });

    addCustomEventListener(_messageClose, 'click', (e) => {
      e.preventDefault();

      if (hasClass(_message, showedClass)) {
        closeMsg();
      }
    });
  };

  const init = () => {
    initConnect();
  };
  init();
}
$('document').ready(() => {
    connectPanel();
});
